module.exports = __webpack_public_path__ + "img/logo.3aa932f9.png";